export default __webpack_public_path__ + "static/media/impressionism.7485e243.png";